module.exports = __webpack_public_path__ + "static/img/nccg_product01.043cb9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/nccg_product01.png
// module id = E0Ii
// module chunks = 19